var _rect, _rect2, _rect3, _g, _rect4, _rect5, _g2, _rect6, _rect7, _g3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFaq(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 56,
    viewBox: "0 0 55 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 54.1558,
    height: 55.1587,
    rx: 7.25149,
    fill: "#C0D8D4"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 34.153,
    height: 5.64734,
    rx: 1.3446,
    transform: "matrix(-1 0 0 1 50.6475 17.1348)",
    fill: "url(#paint0_linear_6386_29628)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 34.153,
    height: 5.64734,
    rx: 1.3446,
    transform: "matrix(-1 0 0 1 50.6475 17.1348)",
    fill: "black",
    fillOpacity: 0.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3.83887,
    y: 12.958,
    width: 14,
    height: 14,
    rx: 2.33333,
    fill: "url(#paint1_linear_6386_29628)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.83887,
    y: 12.958,
    width: 14,
    height: 14,
    rx: 2.33333,
    fill: "black",
    fillOpacity: 0.1
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 34.153,
    height: 5.64734,
    rx: 1.3446,
    transform: "matrix(-1 0 0 1 47.4062 31.6582)",
    fill: "url(#paint2_linear_6386_29628)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 34.153,
    height: 5.64734,
    rx: 1.3446,
    transform: "matrix(-1 0 0 1 47.4062 31.6582)",
    fill: "black",
    fillOpacity: 0.1
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7.08008,
    y: 30.7227,
    width: 7.51782,
    height: 7.51782,
    rx: 1.25297,
    fill: "url(#paint3_linear_6386_29628)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.08008,
    y: 30.7227,
    width: 7.51782,
    height: 7.51782,
    rx: 1.25297,
    fill: "black",
    fillOpacity: 0.1
  }))), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 34.153,
    height: 5.64734,
    rx: 1.3446,
    transform: "matrix(-1 0 0 1 47.4062 42.9414)",
    fill: "url(#paint4_linear_6386_29628)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 34.153,
    height: 5.64734,
    rx: 1.3446,
    transform: "matrix(-1 0 0 1 47.4062 42.9414)",
    fill: "black",
    fillOpacity: 0.1
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7.08008,
    y: 42.0059,
    width: 7.51782,
    height: 7.51782,
    rx: 1.25297,
    fill: "url(#paint5_linear_6386_29628)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.08008,
    y: 42.0059,
    width: 7.51782,
    height: 7.51782,
    rx: 1.25297,
    fill: "black",
    fillOpacity: 0.1
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6386_29628",
    x1: 7.01694,
    y1: 1.58039e-8,
    x2: 8.51613,
    y2: 10.1577,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#026051"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B5F59",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#47A092"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6386_29628",
    x1: 6.71526,
    y1: 12.958,
    x2: 19.4975,
    y2: 27.2786,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#026051"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B5F59",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#47A092"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6386_29628",
    x1: 7.01694,
    y1: 1.58039e-8,
    x2: 8.51613,
    y2: 10.1577,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#026051"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B5F59",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#47A092"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_6386_29628",
    x1: 8.62466,
    y1: 30.7227,
    x2: 15.4886,
    y2: 38.4126,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#026051"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B5F59",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#47A092"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_6386_29628",
    x1: 7.01694,
    y1: 1.58039e-8,
    x2: 8.51613,
    y2: 10.1577,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#026051"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B5F59",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#47A092"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_6386_29628",
    x1: 8.62466,
    y1: 42.0059,
    x2: 15.4886,
    y2: 49.6959,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#026051"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B5F59",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#47A092"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaq);
export default __webpack_public_path__ + "static/media/faq.b8523b1f11ca150909440f2a0ba0b8f6.svg";
export { ForwardRef as ReactComponent };